module.exports = __webpack_public_path__ + "img/2-images-tt.c8447d02.png";